@if (!isLoading) {
  <div class="container">
    <div class="header-container">
      @if (icon) {
        <mat-icon> {{ icon }} </mat-icon>
      }
      <p class="title">{{ title }}</p>
    </div>
    @if (dialogMode != 0) {
      <div class="text-dve">
        <p>{{ textAboveDVE.firstLine }}</p>
        <p>{{ textAboveDVE.secondLine }}</p>
        <br />
        <label>{{ textAboveDVE.firstLabel }}</label>
        <p>{{ textAboveDVE.firstItem }}</p>
        <br />
        <label>{{ textAboveDVE.secondLabel }}</label>
        <p>{{ textAboveDVE.secondItem }}</p>
        <br />
        <p>{{ textAboveDVE.infoLine }}</p>
      </div>
    }
    <div class="form-container">
      <cotecna-nf-form
        #naturalForm
        [config]="formConfig"
        [sections]="sections"
        [controls]="controls"
        (fieldChange)="onFieldChange($event)"
        >
      </cotecna-nf-form>
    </div>
    @if (showErrorMessage) {
      <div class="info-message">
        <mat-icon class="info">info</mat-icon>
        <p>
          Error: Events for this item have been already imported before. Please
          select a different item for importing events
        </p>
      </div>
    }
    <div class="buttons-container">
      <button (click)="onLeftButtonClick()" mat-button>
        {{ leftButtonText }}
      </button>
      <button
        [disabled]="!isValidForm()"
        (click)="onRightButtonClick()"
        mat-raised-button
        color="primary"
        >
        {{ rightButtonText }}
      </button>
    </div>
  </div>
} @else {
  <mat-spinner class="center-loading" diameter="32"></mat-spinner>
}

